import Image from 'next/image';
import Link from 'next/link';
// import { useRouter } from 'next/navigation';
import React from 'react';
import { IMovie } from '@/interfaces/movie';

function CardMovie({ data }: { data: IMovie }) {
  return (
    <a
      href={`/phim/${data.slug}`}
      className="relative group cursor-pointer"
      // onClick={() => {
      //   router.push(`/phim/${data.slug}`);
      // }}
    >
      <div className="absolute group-hover:flex hidden h-full w-full bg-white opacity-30"></div>
      <div className="absolute z-10 group-hover:flex hidden h-full w-full  items-center justify-center">
        <Image
          src={'/images/play-button.png'}
          unoptimized
          quality={100}
          height={40}
          width={40}
          alt="icon play"
        />
      </div>
      <Image
        width={100}
        height={100}
        unoptimized
        quality={100}
        alt=""
        className="h-72 max-xl:h-64 w-full object-cover"
        src={
          data.thumb_url ??
          'https://phim.nguonc.com/public/images/Post/4/khanh-bon-giai-nhan.jpg'
        }
      />
      <div className="absolute top-3 left-1 text-white font-medium text-[13px] max-md:text-[10px] py-[2px] px-[3px] bg-redMain">
        {data.current_episode}
      </div>
      <div className="text-center bottom-1 w-full leading-4 mt-2 mb-1 max-md:mb-0 left-1 right-1 text-yellowMain line-clamp-1 text-[15px] max-md:text-[12px] font-medium">
        {data.name}
      </div>
      <div className="line-clamp-1 text-center text-white text-[12px]">
        {data.original_name}
      </div>
    </a>
  );
}

export default CardMovie;
